module.exports = __webpack_public_path__ + "img/Barriles.d89d0bf0.jpg";